import { Box, FloatingIndicator, rem } from '@mantine/core';
import { Link, useMatchRoute, useParams } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './order-nav.module.css';

const data = ['points', 'map', 'track'] as const;

export function OrderNav() {
  const { id } = useParams({
    from: '/_app/_admin/orders_/$id',
  });
  const matchRoute = useMatchRoute();
  const isOnMap = matchRoute({ to: '/orders/$id/map' });
  const isOnPoints = matchRoute({ to: '/orders/$id/points' });
  const isOnTrack = matchRoute({ to: '/orders/$id/track' });
  const { t } = useTranslation();

  const [rootRef, setRootRef] = useState<HTMLDivElement | null>(null);
  const [controlsRefs, setControlsRefs] = useState<
    Record<string, HTMLAnchorElement | null>
  >({});

  // Determine active index based on current route
  const active = isOnPoints ? 0 : isOnMap ? 1 : isOnTrack ? 2 : 0;

  const setControlRef = (index: number) => (node: HTMLAnchorElement) => {
    controlsRefs[index] = node;
    setControlsRefs(controlsRefs);
  };

  const controls = data.map((item: (typeof data)[number], index) => {
    return (
      <Link
        className={classes.control}
        key={item}
        params={{ id }}
        ref={setControlRef(index)}
        to={`/orders/$id/${item}`}
      >
        <span className={classes.controlLabel}>
          {t(`sampling.nav.${item}`)}
        </span>
      </Link>
    );
  });

  return (
    <Box className={classes.root} h={rem(36)} ref={setRootRef}>
      {controls}

      <FloatingIndicator
        className={classes.indicator}
        parent={rootRef}
        target={controlsRefs[active]}
      />
    </Box>
  );
}
